<template>
	<div class="loginView">
		<div class="logoImg">
			<img src="../common/images/member.png" alt="和数传媒">
		</div>
		<form method="post" @submit.prevent="onSubmit()" class="formGroup">
			<div class="input-group box align-center">
				<i class="iconfont user">&#xe6b6;</i>
				<input type="text" placeholder="请输入手机号" class="flex-1" v-model.trim="phone" @blur.prevent = "blurPhone">
				<i class="iconfont clear" v-show="phone != ''" @click="phone = ''">&#xe61f;</i>
			</div>
			<div class="input-group box align-center">
				<i class="iconfont pass">&#xe623;</i>
				<input type="password" placeholder="请输入密码" class="flex-1" v-model.trim="pass" @blur.prevent = "blurPass">
				<i class="iconfont clear" v-show="pass != ''" @click="pass = ''">&#xe61f;</i>
			</div>
			<div class="btn-bar">
				<input type="submit" class="submit" :disabled="isDisabled"
            :class="{disabled: isDisabled}" value="登录">
			</div>
		</form>
		<div class="btn-bar">
			<router-link :to="{name:'registerView'}">注册</router-link>	
		</div>
		<tip :msgControl="msgShow"><p slot="content">{{tipText}}</p></tip>
	</div>
</template>
<script>
	import tip from '../components/tip.vue'
	export default {
		data () {
			return {
				phone: '',
				pass: '',
				msgShow: false,
				tipText: '',
				phoneState: false,
				passState: false,
				isDisabled: false,
				timeOut:null
			}
		},
		methods : {
			msg (){
				this.msgShow =true;
				clearTimeout(this.timeOut);
				this.timeOut = setTimeout(() => {
                   this.msgShow =false;
				}, 2000)
			},
			blurPhone (data){
				if(this.phone == ""){
					this.msg()
					this.tipText = "请输入手机号码"
					this.phoneState = false
				}
				else if(!/(^(1[3|4|5|6|7|8|9])\d)\d{8}$/.test(this.phone)){
					this.msg()
					this.tipText = "请输入正确的手机号码"
					this.phoneState = false
				}else{
					this.phoneState = true
				}
			},
			blurPass () {
				if(this.pass == ""){
					this.msg()
					this.tipText = "密码不能为空"
					this.passState = false
				}else if(this.pass.length<6){
					this.msg()
					this.tipText = "密码不能少于6位"
					this.passState = false
				}
				else if(this.pass.length>32){
					this.msg()
					this.tipText = "密码不能大于32位"
					this.passState = false
				}
				else if(!/^[A-Za-z0-9]{6,32}$/.test(this.pass)){
					this.msg()
					this.tipText = "请输入6-32位字母或数字组合密码"
					this.passState = false
				}else{
					this.passState = true
				}
			},
			clearVal (model) {
				this.model = '';
			},
			beforeSubmit () {
				this.isDisabled = true;
			},
			onSubmit () {
				this.beforeSubmit();
				if(this.phoneState ==false || this.passState == false){
					this.msg()
					this.tipText = "请核对后再提交"
					this.isDisabled = false;
					return false
				}
				this.$post('api/login',{'mobile': this.phone,'password': this.pass
				})
				.then( res => {
					console.log(res);
					if(res.code != 200){
						this.msg()
						this.tipText = res.msg;
						this.isDisabled = false;
					}else if (res.code == 200) {
						this.msg()
						this.tipText = res.msg;
						this.isDisabled = true;
						document.cookie="token="+res.data.token;
						document.cookie="mobile="+res.data.mobile;
						document.cookie="name="+encodeURIComponent(res.data.user_nickname);
						let back = this.$route.params.from
						setTimeout(() =>{
							if(back == 'member'){
								this.$router.push({ name: 'memberIndex'})
							}
							else{
								this.$router.go(-1);
							}
						}, 2000)
					}
				})
			}
		},
		components:{
			tip
		}
	}
</script>
<style lang="scss">
.loginView{
	padding-top:1.4rem;
	.logoImg{
		width: 1.5rem;
		margin: 0 auto;
		margin-bottom:1.6rem;
	}
	.formGroup{
		padding:0 .5rem;
		.input-group{
			border-bottom:1px solid #dddddd;
			margin-bottom:25px;
			height: .73rem;
			.iconfont{
				margin:0 .3rem;
				font-size:.5rem;
				color:#4868af;
				&.clear{
					font-size:.3rem;
					color:#aaaaaa;
					margin-left:0;
				}
			}
			input{
				border:none;
				padding:0;
				background:none;
				font-size:.28rem;
				height: .42rem;
				outline: none;
			}
		}
		.btn-bar{
			margin-top:1.05rem;
			.submit{
				background: linear-gradient(to bottom, #799ff2 , #2451b3);
				border:none;
				padding:0;
				color:#fff;
				width: 90%;
				display:block;
				margin:0 auto;
				height: .8rem;
				border-radius:.4rem;
				outline: none;
				font-size:.36rem;
			}
		}
	}
	&>.btn-bar{
		margin-top:2rem;
		text-align:center;
		a{
			display:inline-block;
			height: .6rem;
			line-height:.6rem;
			padding:0 .5rem;
			border-radius:.1rem;
			border:1px solid #4868af;
			color: #4868af;
			font-size:.28rem;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/page/loginView.vue